import { useQuery } from "@apollo/client";
import { Button, Card, Col, Modal, Row, Typography } from "antd";
import React from "react";
import { GET_USER_NAME } from "../../../Graphql/queries";
import Logo from "../../../Assets/Images/logo.png";
import { logout } from "../../../Utils/functions/common";
import { CustIcon } from "../../Svgs";

const { Title } = Typography;

export const OnboardingModal = ({ closeModal }) => {
  const { data: userNameData } = useQuery(GET_USER_NAME, {
    variables: { user_id: localStorage.getItem("user_id") },
  });

  return (
    <Modal
      centered
      visible
      footer={null}
      width={1000}
      wrapClassName="welcomeSuccessModelPOP"
    >
      <div className="welcomeSuccessModel">
        <div className="welcomeSuccessLogo">
          <img src={Logo} alt="" />
        </div>
        <Title level={1} className="text-center">
          Welcome {userNameData && userNameData?.getUsersById?.first_name} We're
          here to help you get things rolling.
        </Title>
        <Row
          gutter={80}
          className="welcomeSuccessListing justify-content-center"
        >
          <Col md={8} sm={12} xs={24} className="mb-3">
            <Card className="welcomeSuccessCard">
              <div className="welcomeSuccessIcon">
                <CustIcon type="location" />
              </div>
              <h5>Setup your locations</h5>
              <p>Manage your store locations</p>
            </Card>
          </Col>
          <Col md={8} sm={12} xs={24} className="mb-3">
            <Card className="welcomeSuccessCard">
              <div className="welcomeSuccessIcon">
                <CustIcon type="total-employees" />
              </div>
              <h5>Setup your employee</h5>
              <p>Manage your employees and their roles</p>
            </Card>
          </Col>
          <Col md={8} sm={12} xs={24} className="mb-3">
            <Card className="welcomeSuccessCard">
              <div className="welcomeSuccessIcon">
                <CustIcon type="reports" />
              </div>
              <h5>Setup employee reporting</h5>
              <p>Manage reporting for all your employees</p>
            </Card>
          </Col>
        </Row>
        <div className="text-center pt-4">
          <Button
            type="primary"
            shape="round"
            size="large"
            htmlType="submit"
            className="mr-2 mr-md-4"
            onClick={closeModal}
          >
            Continue
          </Button>
          <Button shape="round" htmlType="button" onClick={() => logout()}>
            Logout
          </Button>
        </div>
      </div>
    </Modal>
  );
};
